import { createAction, props } from '@ngrx/store'
import { Update } from '@ngrx/entity'

import { User } from './auth.model'
import { AuthResponse } from '../../../core/auth/auth.model'

export interface CommonResponse {
  message: string
  data: any
}

export const loadUsers = createAction('[User/API] Load Users')

export const addUser = createAction(
  '[User/API] Add User',
  props<{ user: User }>()
)
export const registerUser = createAction(
  '[User/API] Register User',
  props<{ user: User }>()
)

export const registerUserSuccess = createAction(
  '[User/API] Register User Success',
  props<{ user: User }>()
)

export const upsertUser = createAction(
  '[User/API] Upsert User',
  props<{ user: User }>()
)

/*
export const successLoadUser = createAction(
  '[User/API] success Load User',
  props<{ user: User }>()
)
  */

export const resendVerificationTicket = createAction(
  '[User Auth/API] Resent Verification Ticket',
  props<{
    email: string
  }>()
)

export const sendVerificationEmail = createAction(
  '[User Auth/API] Send Verification Email',
  props<{
    email: string
  }>()
)

/* *****  CHANGE PASSWORD ACTIONS ****** */
export const changeUserPassword = createAction(
  '[User/API] change password',
  props<{
    currentPassword: string
    newPassword: string
    confirmPassword: string
  }>()
)

/* ***** CHANGE NAME ACTIONS INCLUDING SUCCESS AND FAILURE ****** */
export const changeName = createAction(
  '[User/API] change name',
  props<{
    newName: string
    redirect?: boolean
  }>()
)

export const changeNameSuccess = createAction(
  '[User/API] Change Name Success',
  props<{ response: CommonResponse; redirect?: boolean }>()
)

export const changeNameError = createAction(
  '[User/API] User Name Update Failure',
  props<{ error: any }>()
)

/* ***** GENERIC ACTIONS OF SUCCESS AND FAILURE OF CHANGE CREDENTIALS ****** */
export const changeCredentialsSuccess = createAction(
  '[User/API] Change Credentials Success',
  props<{ response: any }>()
)

export const error = createAction(
  '[User/API] User Settings update Failure',
  props<{ error: any }>()
)
export const successResendInviteOrganizationMember = createAction(
  '[Authentication/API] Success Resend Verification Ticket',
  props<{ response: any }>()
)

export const authLogin = createAction(
  '[Auth] Login',
  props<{ username: string; password: string }>()
)

export const loginFailure = createAction(
  '[Auth] Failed Login',
  props<{ error: any }>()
)
